import { HttpInterceptorFn } from "@angular/common/http";

/**
 * Interceptor de loader global.
 * El loader solo cubre la transición de ruta (lazy loading, guards).
 * Los requests HTTP que los componentes disparan en ngOnInit ya no extienden
 * el loader para evitar bloquear el menú mientras se cargan dashboards y gráficos.
 */
export const globalLoadingInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req);
};
